import { AdminRouter } from 'stylemix-vue-admin'
import { messageGroups } from '../plugins/i18n'
import { AdminSidebar } from '../stylemix-vue-admin'

AdminRouter.addRoute({
  path: '/',
  name: 'dashboard',
  component: () => import('./Dashboard.vue'),
  meta: {
    auth: true,
  },
})
AdminRouter.addRoute({
  path: '/charts/earning',
  component: () => import('./Earning.vue'),
  meta: {
    auth: true,
  },
})

AdminSidebar.pushItem({
  id: `/`,
  order: 0,
  // header: $vm => $vm.$t(`general.locations_and_rules`),
  text($vm) {
    return $vm.$t(`general.dashboard`)
  },
  route: {
    name: `/`,
  },
  icon: 'icon-chart',
  permission: 'users.index',
})

messageGroups.push('graphs')
